// extracted by mini-css-extract-plugin
export default {"reviews_container":"reviews-form_reviews_container__3p7Yh","review_card_wrapper":"reviews-form_review_card_wrapper__WD42e","movable":"reviews-form_movable__BAZHl"};